import { useEffect, useState } from "react";

import { CookieKeys } from "@/enums/CookieKeys.enum";
import { useCookies } from "@/hooks/useCookies";

const useGetUserCountry = (): {
  country: string | null;
  location: string | null;
  loading: boolean;
  error: string | null;
} => {
  const [country, setCountry] = useState<string | null>(null);
  const [location, setLocation] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { setCookie, getCookie } = useCookies();

  useEffect(() => {
    const userCountry = getCookie(CookieKeys.UserCountry);
    const userLocation = getCookie(CookieKeys.UserLocation);
    if (userCountry && userLocation) {
      setLocation(userLocation);
      setCountry(userCountry);
      return;
    }

    const fetchTraceData = async (): Promise<void> => {
      try {
        const response = await fetch("https://mygwork.com/cdn-cgi/trace");

        if (!response.ok) {
          throw new Error("Failed to fetch trace data");
        }

        const text = await response.text();
        const traceObj = text
          .split("\n")
          .reduce<{ [key: string]: string }>((acc, line) => {
            const [key, value] = line.split("=");
            if (key && value) {
              acc[key] = value;
            }
            return acc;
          }, {});

        setCountry(traceObj.loc || null);
        setCookie({
          key: CookieKeys.UserCountry,
          value: country || "",
        });

        setLocation(traceObj.colo || null);
        setCookie({
          key: CookieKeys.UserLocation,
          value: location || "",
        });
      } catch (err) {
        const errorMessage = (err as Error).message;
        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchTraceData();
  }, []);

  return { country, location, loading, error };
};

export default useGetUserCountry;
